import api from "./api";

/**
 * Servicio para interactuar con la API de Notas de Crédito
 */
const creditNoteService = {
  /**
   * Obtener lista de notas de crédito con filtros y paginación
   * @param {Object} params - { search, from, to, estado_dte, status, page }
   */
  getAll: async (params = {}) => {
    const response = await api.get("/credit-notes", { params });
    return response.data;
  },

  /**
   * Obtener una nota de crédito por ID
   */
  getById: async (id) => {
    const response = await api.get(`/credit-notes/${id}`);
    return response.data;
  },

  /**
   * Obtener una nota de crédito por número de control
   */
  getByControl: async (numeroControl) => {
    const response = await api.get(`/credit-notes/by-control/${numeroControl}`);
    return response.data;
  },

  /**
   * Crear una nueva nota de crédito
   * @param {Object} data - { sale_id, motivo, revertir_inventario }
   */
  create: async (data) => {
    const response = await api.post("/credit-notes", data);
    return response.data;
  },

  /**
   * Cancelar una nota de crédito
   */
  cancel: async (id) => {
    const response = await api.delete(`/credit-notes/${id}`);
    return response.data;
  },

  /**
   * Obtener estadísticas de notas de crédito
   * @param {Object} params - { from, to }
   */
  getStats: async (params = {}) => {
    const response = await api.get("/credit-notes/stats", { params });
    return response.data;
  },

  /**
   * Descargar PDF de la nota de crédito
   */
  downloadPdf: async (id, numeroControl) => {
    const response = await api.get(`/credit-notes/${id}/pdf`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `NC_${numeroControl}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  /**
   * Descargar JSON de la nota de crédito
   */
  downloadJson: async (id, numeroControl) => {
    const response = await api.get(`/credit-notes/${id}/json`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `NC_${numeroControl}.json`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  /**
   * Descargar JSON firmado de la nota de crédito
   */
  downloadJsonFirmado: async (id, numeroControl) => {
    const response = await api.get(`/credit-notes/${id}/json-firmado`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `NC_${numeroControl}_firmado.json`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  /**
   * Obtener contenido del JSON para visualizar
   */
  getJsonContent: async (id) => {
    const response = await api.get(`/credit-notes/${id}/json-content`);
    return response.data;
  },
};

export default creditNoteService;